module.exports = __webpack_public_path__ + "static/media/transporte.15a4ed73.svg";